import clsx from "clsx";

export const SpinnerIcon = ({ className = null, children }) => {
  const classes = clsx("spinner-border", "text-primary", ...(Array.isArray(className) ? className : [className]));
  return (
    <output className={classes}>
      <span className="visually-hidden">{children}</span>
    </output>
  );
};

const Spinner = ({ show, spinnerClasses = null, children }) => {
  return (
    <>
      {show ? (
        <div className="text-center p-4 " style={{ height: "auto" }}>
          <SpinnerIcon className={spinnerClasses} />
        </div>
      ) : (
        <>{children}</>
      )}
    </>
  );
};

export default Spinner;
